import {
  Box,
  Circle,
  Edit3,
  File,
  FileText,
  FolderMinus,
  FolderPlus,
  Home,
  Send,
  Trello,
  User,
  XCircle,
  BookOpen,
  UserCheck,
} from 'react-feather'
import { documentStatusGlobal } from '../../utility/helpers'

export default [
  {
    id: 'digitalSignature',
    title: 'Firma Digital',
    icon: <Edit3 size={20} />,
    navLink: '/digital-signature',
    children: [
      {
        id: 'home',
        title: 'Home',
        icon: <Home size={20} />,
        navLink: '/home',
      },
      {
        id: 'documents',
        title: 'Documentos',
        icon: <File size={20} />,
        navLink: `/documents`,
        children: [
          {
            id: 'created',
            title: 'Borradores',
            icon: <FolderPlus size={12} />,
            navLink: `/documents/${documentStatusGlobal.created}`,
          },
          {
            id: 'sent',
            title: 'Enviados',
            icon: <Send size={12} />,
            navLink: `/documents/${documentStatusGlobal.sent}`,
          },
          {
            id: 'signed',
            title: 'Firmados',
            icon: <Circle size={12} />,
            navLink: `/documents/${documentStatusGlobal.signed}`,
          },
          {
            id: 'refused',
            title: 'Rechazados',
            icon: <FolderMinus size={12} />,
            navLink: `/documents/${documentStatusGlobal.refused}`,
          },
          {
            id: 'canceled',
            title: 'Anulados',
            icon: <XCircle size={12} />,
            navLink: `/documents/${documentStatusGlobal.canceled}`,
          },
        ],
      },
      {
        id: 'templates',
        title: 'Plantillas',
        icon: <FileText size={20} />,
        navLink: '/templates',
      },
      {
        id: 'signers',
        title: 'Firmantes',
        icon: <Edit3 size={20} />,
        navLink: '/signers',
      },
      {
        id: 'Area',
        title: 'Area',
        icon: <Box size={20} />,
        navLink: '/area',
      },
      {
        id: 'societies',
        title: 'Sociedades',
        icon: <Trello size={20} />,
        navLink: '/societies',
      },
      {
        id: 'signatoriesSocieties',
        title: 'Firmantes Sociedad',
        icon: <Trello size={20} />,
        navLink: '/signatories-societies',
      },
      {
        id: 'companyPositions',
        title: 'Posiciones',
        icon: <Trello size={20} />,
        navLink: '/company-positions',
      },
      {
        id: 'Companies',
        title: 'Compañias',
        icon: <Trello size={20} />,
        navLink: '/companies',
      },
      {
        id: 'usuario',
        title: 'Usuario',
        icon: <Trello size={20} />,
        navLink: '/users',
      },
    ],
  },
  {
    id: 'billing',
    title: 'Facturación',
    icon: <FileText size={20} />,
    navLink: '/billing',
    children: [
      {
        id: 'invoices',
        title: 'Factura electronica',
        icon: <FileText size={20} />,
        navLink: '/invoices',
        settings: {
          area: 'Facturacion',
        },
      },
      // se oculta esta opcion del menu hasta que se definan los requerimientos
      // {
      //   id: "customer-master-latitude",
      //   title: "Maestro de clientes L.",
      //   icon: <Users size={20} />,
      //   navLink: "/customer-master-latitude",
      //   settings: {
      //     area: "Facturacion"
      //   },
      // },

      // {
      //   id: "issuance-of-invoices",
      //   title: "Emisión de facturas",
      //   icon: <FileText size={20} />,
      //   navLink: "/issuance-of-invoices",
      //   settings: {
      //     area: "Facturacion"
      //   },
      // },
      {
        id: 'docs-error',
        title: 'Documentos con error',
        icon: <File size={20} />,
        navLink: '/docs-error',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'sales-book',
        title: 'Libro de ventas',
        icon: <BookOpen size={20} />,
        navLink: '/sales-book',
        settings: {
          area: 'Facturacion',
        },
        children: [
          {
            id: 'sales-book',
            title: 'Contribuyentes',
            icon: <BookOpen size={20} />,
            navLink: '/sales-book',
            settings: {
              area: 'Facturacion',
            },
          },
          {
            id: 'end-customer',
            title: 'Consumidor Final',
            icon: <UserCheck size={20} />,
            navLink: '/end-customer',
            settings: {
              area: 'Facturacion',
            },
          },
        ],
      },

      {
        id: 'invoice-issuance',
        title: 'Emisión de facturas',
        icon: <File size={20} />,
        navLink: '/invoice-issuance',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'credit-note',
        title: 'Anulaciones',
        icon: <File size={20} />,
        navLink: '/debit-credit-note/note',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'debit-note',
        title: 'Nota débito',
        icon: <File size={20} />,
        navLink: '/debit-credit-note/debit-note',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'customer-master',
        title: 'Maestro de cliente',
        icon: <File size={20} />,
        navLink: '/customer-master',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'product-services-master',
        title: 'Productos/Servicios',
        icon: <File size={20} />,
        navLink: '/product-service-master',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'business-manager',
        title: 'Parámetros de Emisor',
        icon: <User size={20} />,
        navLink: '/business-manager',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'freports',
        title: 'Documentos Emitidos',
        icon: <File size={20} />,
        navLink: '/reports',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'freception',
        title: 'Recepción de Documentos',
        icon: <File size={20} />,
        navLink: '/reception-documents',
        settings: {
          area: 'Facturacion',
        },
      },
    ],
  },

  {
    id: 'temporal-billing',
    title: 'Facturación',
    icon: <FileText size={20} />,
    navLink: '/billing',
    children: [
      {
        id: 'invoices',
        title: 'Factura electronica',
        icon: <FileText size={20} />,
        navLink: '/invoices',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'docs-error',
        title: 'Documentos con error',
        icon: <File size={20} />,
        navLink: '/docs-error',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'business-manager',
        title: 'Parámetros de Emisor',
        icon: <User size={20} />,
        navLink: '/business-manager',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'tbreports',
        title: 'Documentos Emitidos',
        icon: <File size={20} />,
        navLink: '/reports',
        settings: {
          area: 'Facturacion',
        },
      },
      {
        id: 'tbreception',
        title: 'Recepción de Documentos',
        icon: <File size={20} />,
        navLink: '/reception-documents',
        settings: {
          area: 'Facturacion',
        },
      },
    ],
  },

  /*{
    id: "signature",
    title: "Firmas",
    icon: <Database size={20} />,
    navLink: "/signature"
  }*/
]
